import * as spinnerActionTypes from "./spinnerActionTypes";

const initialState = {
  loading: false,
};

const spinnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case spinnerActionTypes.SHOW_SPINNER:
      return {
        loading: true,
      };
    case spinnerActionTypes.HIDE_SPINNER:
      return {
        loading: false,
      };
    default:
      return state;
  }
};

export default spinnerReducer;
